
<template>
  <dc-layout-main>
    <dc-layout-content>
      <CosViewContent>
      <baseMessage  :data="data" />
    </CosViewContent>
    </dc-layout-content>
  </dc-layout-main>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue'
import baseMessage from './components/baseMessage.vue'
import { useRoute } from 'vue-router'
import { signInRecordDetail } from '@/api/systemSetting/visitToSign'
const route = useRoute()
const data = ref({})
// 获取详情
const fetch = () => {
  if (route.query.id) {
    signInRecordDetail({ id: route.query.id }).then((res) => {
      data.value = res.data
    })
  }
}
onMounted(() => {
  fetch()
})
</script>
<style lang="scss" scoped></style>
